<script>
import Form, { formCreate } from '../../../../../../components/form';
import formAdd from './components';
import request from '../../../../../../utils/request';

formCreate.component('formAdd', formAdd);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      rule: [],
      row: null,
    };
  },
  async created() {
    const rule = await this.getFormRule('competitor_product_management_add');
    const newRule = [];
    rule.forEach((item) => {
      const v = item;
      if (v.field === 'brandName') {
        if (this.formConfig.type === 'view') {
          this.buttons.submit = false;
          newRule.push({
            type: 'formAdd',
            field: 'brandName',
            title: '',
            value: {},
            props: {
              disabled: true,
            },
          });
        } else {
          newRule.push({
            type: 'formAdd',
            field: 'brandName',
            title: '',
            value: {},
          });
        }
      }
    });
    this.rule = newRule;
    this.reload(this.rule);
    if (this.formConfig.type === 'edit' || this.formConfig.type === 'view') {
      request
        .get('/sfa/sfavisitstepcolletproduct/query', {
          id: this.formConfig.id,
        })
        .then((res) => {
          if (res.success) {
            const { result } = res;
            const brandName = {
              brandName: result,
            };
            this.setValue(brandName);
            this.row = res.result;
          }
        });
    }
  },
  methods: {
    // 提交
    submit() {
      const formData = this.getFormData().brandName;
      if (formData) {
        let url = '/sfa/sfavisitstepcolletproduct/save';
        let params = { ...formData };

        if (this.formConfig.type === 'edit') {
          url = '/sfa/sfavisitstepcolletproduct/update';
          params = Object.assign(this.row, formData);
        }

        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });

            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
</script>
